import { ENDPOINTS } from "@/constants/endpoints";

// Endpoints that skip user token injection in beforeRequest.
// These are pre-authentication endpoints that are called before a user token
// exists (login, registration, password reset, OTP resend, etc.).
export const PUBLIC_ENDPOINTS = [
  ENDPOINTS.AUTH.LOGIN_EMAIL,
  ENDPOINTS.AUTH.LOGIN_EMAIL_VERIFY,
  ENDPOINTS.AUTH.REGISTER_EMAIL,
  ENDPOINTS.AUTH.FORGOT_PASSWORD,
  ENDPOINTS.AUTH.RESET_PASSWORD,
  ENDPOINTS.AUTH.SEND_OTP,
  ENDPOINTS.USERS.SELLER.ASSIGN_PASSWORD,
  ENDPOINTS.ADDRESS.COUNTRIES,
  "address/city"
];
